import useNavigationStore from '@src/stores/navigationStore';
import useRegistrationStore from '@src/stores/registrationStore';

import styles from './AccountInformations.module.scss';

import BlockTitle from '@src/components/_shared/UI/BlockTitle';
import BackButton from '@src/components/_shared/BackButton';
import Container from '@src/components/_shared/Container';
import Subtitle from '@src/components/_shared/UI/Subtitle';
import { Form, Formik } from 'formik';
import Input from '@src/components/_shared/UI/Input';
import ValidateButton from '@src/components/_shared/UI/ValidateButton';
import { useState } from 'react';
import ValidateChoiceButton from '@src/components/_shared/UI/ValidateChoiceButton';


export default function AccountInformations() {
    const { setSection, setBlock } = useNavigationStore();
    const { updateAccountField, registration } = useRegistrationStore();
    const [accountType, setAccountType] = useState<boolean>(false);

    const _onGoBack = () => {
        setSection(4)
        setBlock('Informations')
    };

    const _handleSelectOpeningType = (bool: boolean) => {
        updateAccountField(0, 'is_transfer', bool);
        setAccountType(true);
    }

    if (accountType) {
        return(
            <Container>
                <BackButton onClick={() => setAccountType(false)}/>
                <BlockTitle title="Informations concernant le compte que vous allez ouvrir" />
                <Subtitle content="Veuillez prendre connaissance des informations suivantes" />
                <Formik
                    initialValues={{
                        accountTitle: 'Compte titres ordinaire',
                        accountType: 'ord',
                        accountNature: 'Compte simple'
                    }}
                    onSubmit={(values) => {
                        updateAccountField(0, 'title', values.accountTitle)
                        updateAccountField(0, 'type', values.accountType)
                        setBlock('AccountOptions');
                    }}
                >
                    {({ handleChange, handleSubmit, values }) => {
                        return (
                            <Form id="accountInformationsForm" autoComplete="off" className="registerForm">
                                <Input
                                    title="Type de compte"
                                    name="accountTitle"
                                    id="accountTitle"
                                    width="100%"
                                    type="text"
                                    placeholder="Ex : L'Oréal"
                                    value={values.accountTitle}
                                    disabled
                                    onChange={handleChange('accountTitle')}
                                />
                                <Input
                                    title="Nature du compte"
                                    name="accountNature"
                                    id="accountNature"
                                    width="100%"
                                    type="text"
                                    placeholder="Ex : L'Oréal"
                                    value={values.accountNature}
                                    disabled
                                    onChange={handleChange('accountNature')}
                                />
                                <ValidateButton title="Continuer" disabled={!values.accountTitle || !values.accountNature} onClick={handleSubmit} />
                            </Form>
                        )
                    }}
                </Formik>
            </Container>
        )
    }

    return (
        <Container>
            <BackButton onClick={_onGoBack}/>
            <BlockTitle title="Que voulez-vous faire ?" />
            <Subtitle content={`Vous pouvez ouvrir un nouveau compte ou transférer un compte existant vers ${registration.partner_informations.is_partner ? 'Direct Securities' : 'Bourse Direct'}.`} />
            <div className={styles.buttons}>
                <ValidateChoiceButton title="Ouvrir un nouveau compte" selected={registration.accounts[0]?.is_transfer === false} onValidate={() => _handleSelectOpeningType(false)} />
                {/* <ValidateChoiceButton title="Transférer un compte" selected={registration.accounts[0]?.is_transfer === true} onValidate={() => _handleSelectOpeningType(true)} /> */}
                <ValidateChoiceButton title="Transférer un compte" onValidate={() => {}} inactive />
            </div>
        </Container>
    );
}
